/* */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import actions from 'redux/actions';

const { getListPackage } = actions;

export default () => {
  const authReducer = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  return useEffect(() => {
    const { sessionId, isLogin } = authReducer;
    if (isLogin && sessionId) {
      dispatch(getListPackage());
    }
  }, [authReducer.isLogin]);
};
